import { Box, Skeleton, Typography } from "@mui/material";
import moment from "moment/moment";

const Category = ({ about }) => {
  return (
    <Box
      sx={{
        mb: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignContent: "center",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography
          sx={{
            fontSize: "12px",
            lineHeight: "16px",
            width: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          {about?.category.name}

          {!about && <Skeleton width={80} height={17} />}
        </Typography>
      </Box>

      <Typography
        sx={{
          fontSize: "12px",
          lineHeight: "16px",
          display: "flex",
          alignItems: "end",
        }}
      >
        {about ? (
          `Started at ${moment(about.created_at).format("DD/MM/YYYY")}`
        ) : (
          <Skeleton width={90} height={17} sx={{ display: "inline-flex" }} />
        )}
      </Typography>
    </Box>
  );
};
export default Category;
